import React, { useEffect, useState } from 'react';
import TabPanel from '../../../components/TabPanel/TabPanel';
import { Tabs, Tab, Button, TextField, Select, MenuItem } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import Add from '@material-ui/icons/Add';
import { IonSpinner } from '@ionic/react';
import { DeleteForeverOutlined } from '@material-ui/icons';
import { AccountDetails } from '../AccountDetails';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import AGPAY_API from '../../../api-services/feature-api';
import { useHistory } from 'react-router';


interface PaymentGateWayProps {
	tabValue: number;
	index: number;
	paymentOption: string;
	accountDetails: AccountDetails[];
	setShowDeleteModal: (status: boolean) => void;
	setDeleteId: (id: number) => void;
	setAddAccount: (status: boolean) => void;
	withdrawAmount: string;
	setWithdrawAmount: (amount: string) => void;
	loading: boolean;
	setLoading: Function,
	setWithdrawNotes: (notes: string) => void;
	addAccount: boolean;
	setOpenWithdrawModal: Function;
}

const ZenpayCrypto: React.FC<PaymentGateWayProps> = ({
	index,
	paymentOption,
	tabValue,
	accountDetails,
	setDeleteId,
	setShowDeleteModal,
	loading,
	setLoading,
	setAddAccount,
	setWithdrawAmount,
	withdrawAmount,
	addAccount,
	setOpenWithdrawModal
}) => {
	const [mobileNumber, setMobileNumber] = useState<string>();
	const [selectedCrypto, setSelectedCrypto] = useState<any>({});
	const [selectedCryptoAccount, setSelectedCryptoAccount] = useState<any>();
	const [walletAddress, setWalletAddress] = useState<string>();
	const [currencyList, setCurrencyList] = useState<any>([]);
	const [recievableAmount, setReceivableAmount] = useState<string>('');

	const history = useHistory();

	const submitZenpayCryptoPayment = async (e) => {
		e.preventDefault();
		if (Number(withdrawAmount) < 100) {
			toast.error(
				<div>
					<ErrorIcon /> {'Withdrawal Amount cannot be less than 100'}
				</div>,
				{
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				}
			);
			return false;
		}
		setLoading(true);
		try {
			const payload = {
				payment_method: "CRYPTO_WALLET_TRANSFER",
				currency_type: "INR",
				amount: withdrawAmount,
				mobile_number: mobileNumber ? mobileNumber : "9876543211",
				crypto_currency: selectedCryptoAccount.paymentMethodDetails.cryptoCurrency,
				network_id: selectedCryptoAccount.paymentMethodDetails.networkId,
				wallet_address: selectedCryptoAccount.paymentMethodDetails.walletAddress
			}
			const response = await AGPAY_API.post(
				`/agpay/v2/zenpay-crypto/transactions/:withdraw`,
				payload,
				{
					headers: {
						Authorization: sessionStorage.getItem('jwt_token'),
					},
				}
			);
			if (response.status === 200) {
				toast.success(
					<div>
						<SuccessIcon /> Transaction Saved Successfully!
					</div>,
					{
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					}
				);
				// setOpenWithdrawModal(false);
				history.push('/my_transactions');
			} else {
				toast.error(
					<div>
						<ErrorIcon /> {'Something went wrong'}
					</div>,
					{
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					}
				);
			}
			setLoading(false);
		} catch (error) {
			toast.error(
				<div>
					<ErrorIcon /> {error?.response?.data?.message}
				</div>,
				{
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				}
			);
			setLoading(false);
		}
	};

	const getReceivableAmount = async () => {
		if (!withdrawAmount) {
			toast.error(
				<div>
					<ErrorIcon /> {'Enter Amount'}
				</div>,
				{
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				}
			);
			return false;
		}
		try {
			const payload = {
				amount: +withdrawAmount,
			};
			const response = await AGPAY_API.post(
				`/agpay/v2/zenpay-crypto/exchange-rates`,
				payload,
				{
					headers: {
						Authorization: sessionStorage.getItem('jwt_token'),
					},
				}
			);
			if (response.status === 200) {
				response.data?.data.map((currency) => {
					if (
						currency?.network_id == selectedCryptoAccount.paymentMethodDetails.networkId &&
						currency?.crypto_currency == selectedCryptoAccount.paymentMethodDetails?.cryptoCurrency
					) {
						setReceivableAmount(currency?.receivable_amount);
					}
				});
			}
		} catch (err) {
			console.log(err);
		}
	};

	const getCurrencyList = async () => {
		try {
			const response = await AGPAY_API.get(
				`/agpay/v2/zenpay-crypto/currencies`,
				{
					headers: {
						Authorization: sessionStorage.getItem('jwt_token'),
					},
				}
			);
			if (response.status === 200) {
				setCurrencyList(response?.data?.crypto_currency);
			}
		} catch (err) {
			console.log(err);
		}
	};

	const submitDetails = async (e) => {
		e.preventDefault();
		console.log(e);
		setLoading(true);
		try {
			const cryptoPayload = {
				paymentMethod: paymentOption,
				accountNumber: walletAddress,
				cryptoCurrencyType: selectedCrypto.crypto_currency,
				blockchain: selectedCrypto.blockchain,
				networkId: selectedCrypto.network_id
			}

			const response = await AGPAY_API.post(
				`/agpay/v2/pgman/payment-methods`,
				cryptoPayload,
				{
					headers: {
						Authorization: sessionStorage.getItem('jwt_token'),
					},
				}
			);
			if (response.status === 200 || 204) {
				toast.success(
					<div>
						<SuccessIcon /> {'Deatils Saved Successfully!'}
					</div>,
					{
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					}
				);
				history.push('/my_transactions')
				setOpenWithdrawModal(false);
			} else {
				toast.error(
					<div>
						<ErrorIcon /> {'Something went wrong'}
					</div>,
					{
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
					}
				);
			}
			setLoading(false);
		} catch (error) {
			toast.error(
				<div>
					<ErrorIcon /> {error?.response?.data?.message}
				</div>,
				{
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				}
			);

			setLoading(false);
		}
	};

	useEffect(() => {
		getCurrencyList();
		// setSelectedCryptoAccount
	}, [])

	const onChangeAccount = (acc: any) => {
		setAddAccount(false);
		setSelectedCryptoAccount(acc);
		setReceivableAmount('');
	}

	return (
		<TabPanel value={tabValue} index={index}>
			<div className="account-details-ctn">
				<Tabs
					value={1}
					variant="scrollable"
					scrollButtons="off"
					className="actions-list"
				>
					<>
						{accountDetails?.map((acc) => (
							<>
								<>
									<div className="account-btn-ctn">
										<Button
											className={
												acc?.id?.toString() === selectedCryptoAccount?.id?.toString()
													? 'active account-detail-withdraw'
													: 'account-detail-withdraw'
											}
											onClick={() => onChangeAccount(acc)}
										>
											<div className="account-name">
												{acc?.paymentMethodDetails?.cryptoCurrency + ' (' + acc?.paymentMethodDetails?.blockchain + ')'}
											</div>
											<div className="account-number">
												{acc?.paymentMethodDetails?.walletAddress}
											</div>

										</Button>
										<div className="delete-btn-ctn">
											<Button
												className="method-delete-btn"
												onClick={() => {
													setShowDeleteModal(true);
													setDeleteId(acc?.id);
													setSelectedCrypto('');
												}}
											>
												<DeleteForeverOutlined />
											</Button>
										</div>
									</div>
								</>
							</>
						))}
					</>
				</Tabs>
				{paymentOption ? (
					<Button
						title="Add Account"
						onClick={() => {
							setSelectedCryptoAccount(null);
							setAddAccount(true);
						}}
						className="add-btn "
					>
						<div className="add-account ">
							<Add />{' '}
						</div>
					</Button>
				) : null}

			</div>
			{paymentOption === 'CRYPTO_WALLET_TRANSFER' && addAccount && (
				<form
					className="account-inputs"
					onSubmit={(e) => submitDetails(e)}
				>
					<div className="select-template">
						<div className="st-label">Select Currency</div>
						<Select
							value={selectedCrypto}
							// disabled={amountToBePaid ? true : false}
							onChange={(e: any) => setSelectedCrypto(e.target.value)}
							className="select-compo"
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{currencyList.map((indv) => (
								<MenuItem key={indv.crypto_currency} value={indv}>
									{indv.crypto_currency + ' (' + indv.blockchain + ')'}
								</MenuItem>
							))}
						</Select>
					</div>

					<div className="account-input">
						<div className="account-label">Wallet Address</div>
						<TextField
							required
							placeholder="Wallet Address"
							className="acc-input"
							value={walletAddress}
							onChange={(e) => setWalletAddress(e.target.value)}
						/>
					</div>

					<Button
						className="submit-payment-btn"
						type="submit"
						endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
						disabled={loading ? true : false}
					>
						Next
					</Button>
				</form>
			)}
			{selectedCryptoAccount && !addAccount ? (
				<>
					<form
						className="account-inputs"
						onSubmit={(e) => {
							submitZenpayCryptoPayment(e);
						}}
					>
						<div className="payment-option-title">
							Enter Payment Details
						</div>
						<div className="account-input">
							<div className="account-label">Enter Amount</div>
							<NumberFormat
								required
								className="acc-input"
								placeholder="Enter Withdraw Amount"
								value={withdrawAmount}
								decimalSeparator={false}
								disabled={recievableAmount ? true : false}
								onChange={(e) => setWithdrawAmount(e.target.value)}
							/>
						</div>

						{!recievableAmount && <Button
							className="submit-payment-btn"
							// type="submit"
							disabled={loading ? true : false}
							endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
							onClick={() => getReceivableAmount()}
						>
							Next
						</Button>}


						{recievableAmount &&
							<>
								<div className="account-input">
									<div className="account-label">Receivable Amount</div>
									<TextField
										required
										placeholder="Enter Notes"
										className="acc-input"
										disabled
										value={recievableAmount}
									/>
								</div>

								<Button
									className="submit-payment-btn"
									type="submit"
									disabled={loading ? true : false}
									endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
								>
									Submit
								</Button>
							</>
						}


					</form>
				</>
			) : null}
		</TabPanel>
	);
};

export default ZenpayCrypto;